import { buildMeta, getCompanyFromMatches } from "~/utils/meta-helpers";

import { PRIVACY_UPDATED_AT, PrivacyContent } from "../components/legal/PrivacyContent";
import { LegalPage } from "../components/LegalPage";

import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ matches }) => {
  const company = getCompanyFromMatches(matches);
  return buildMeta({
    title: `Política de Privacidad | ${company}`,
    description: "Qué datos tuyos usamos en AcademIA, para qué, y cuáles son tus derechos.",
    path: "/privacy",
  });
};

export default function PrivacyPage() {
  return (
    <LegalPage eyebrow="Legal" title="Política de Privacidad" updatedAt={PRIVACY_UPDATED_AT}>
      <PrivacyContent />
    </LegalPage>
  );
}
